module.exports = __webpack_public_path__ + "static/dave-gordon.d1fc2ca2.webp";